import type { MenuListProps } from "src/atoms/Menu/Menu";
import { MenuListContent } from "../LanguageSwitcher.styled";

function MenuList({ isOpen, onToggle = () => null, children }: MenuListProps) {
  return (
    <MenuListContent>
      {children instanceof Function ? children({ onToggle, isOpen }) : children}
    </MenuListContent>
  );
}

export { MenuList };
